import axios from "axios";
import "api/api";

export type AppointmentConflictRow = {
  id: number;
  date: string;
  start_time_utc: string;
  end_time_utc: string;
  duration: number;
  status: string | null;
  requestId: number | null;
  label: string | null;
};

export type AssigneeConflict = {
  assigneeId: number;
  assigneeName: string;
  appointments: AppointmentConflictRow[];
};

export type CheckAppointmentConflictsResponse = {
  conflicts: AssigneeConflict[];
  hasConflicts: boolean;
};

export type CheckAppointmentConflictsInput = {
  assigneeIds: number[];
  date?: string;
  start_time_utc: string;
  /** Arrival window end — when set, BE uses this for the proposed busy interval. */
  end_time_utc?: string;
  duration?: string | null;
  excludeAppointmentId?: number;
};

export async function checkAppointmentConflicts(
  input: CheckAppointmentConflictsInput
): Promise<CheckAppointmentConflictsResponse> {
  const serverUrl = (process.env.REACT_APP_SERVER_URL || "").trim();
  const res = await axios.post<CheckAppointmentConflictsResponse>(
    `${serverUrl}/api/v2/company/appointments/check-conflicts`,
    input
  );
  return res.data;
}
